import BarcodeScan90daysController from './BarcodeScan90daysController';
import Loader from 'utils/Loader';
//import { greenColor, redColor, whiteColor } from 'utils/constants';
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useDeferredValue } from 'react';

function BarcodeScan90days() {
  const {
    barcodeText,
    barcodeData,
    userVerticalId,
    isLoading,
    barcodeError,
    // handleOkButtonClick,
    handleClearButtonClick,
    handleTextareaResize,
    handleRemoveBarcode,
    handleProceed,
    handleBarcodesChange,
    handleBarcodesPaste,
  } = BarcodeScan90daysController();

  const deferredBarcodeData = useDeferredValue(barcodeData);
  const shouldRenderTable = deferredBarcodeData && deferredBarcodeData.length > 0;
  return (
    <div className="bg" style={{ display: 'block' }}>
      {isLoading ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Data Loading...</span>
        </div>
      ) : null}
      <div className="cutrange">
        <span className="font20">BARCODE SCANNER SALES PLANNING</span>
      </div>
      {/* <div className="cutrange" style={{ justifyContent: 'end' }}>
        <span style={{ marginRight: '20px' }}>Total :</span>
        <input
          value={barcodeData.length}
          readOnly
          type="text"
          name="cfrom"
          style={{ width: '80px', marginRight: '20px', textAlign: 'center' }}
          className={`inp_text`}
          id="cfrom"
        />
      </div> */}
      <div className="vertical-center">
        <div style={{ display: 'flex', flexDirection: 'row', width: '80%' }}>
          <div style={{ flex: 1 }}>
            <textarea
              type="text"
              name="barcodes"
              value={barcodeText}
              className={`form-control inp_text`}
              id="barcodes"
              rows={7}
              cols={50}
              onChange={(e) => handleBarcodesChange(e)}
              onPaste={handleBarcodesPaste}
              onInput={handleTextareaResize}
              autoFocus
            />
          </div>
          {/* <div style={{ marginTop: 'auto', marginBottom: '10px', marginLeft: '10px' }}>
            <button onClick={handleOkButtonClick}>OK</button>
          </div> */}
        </div>
        <div style={{ width: '80%' }}>
          <p className="error">{barcodeError}</p>
        </div>
        {shouldRenderTable ? (
          <div className="barcode-so">
            <Paper
              elevation={3}
              sx={{
                width: '100%',
                margin: 'auto',
                borderRadius: '8px',
                overflow: 'hidden'
              }}
            >
              <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid #e5e5e5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  Barcode List ({barcodeData.length})
                </Typography>
                
              </Box>
              <TableContainer sx={{ maxHeight: 460, overflowX: 'auto' }}>
                <Table stickyHeader size="small" aria-label="Scanned barcode items">
                  <TableHead>
                    <TableRow>
                      {['Barcode', 'Material', 'Action'].map((heading) => (
                        <TableCell key={heading} sx={{ fontWeight: 700, color: '#243247', bgcolor: '#eef2f7', whiteSpace: 'nowrap' }}>{heading}</TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {deferredBarcodeData.map((item, index) => (
                      <TableRow key={`${item.barcode || item.materialID || 'item'}-${index}`} hover>
                        <TableCell sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{(String(userVerticalId).toLowerCase() === 'fabric' ? item.serialB : item.barcode) || '-'}</TableCell>
                        <TableCell sx={{ minWidth: 190 }}>{item.materialDesc || item.mainGroup || '-'}</TableCell>
                        <TableCell>
                          <Button size="small" color="error" variant="outlined" onClick={() => handleRemoveBarcode(index)}>
                            Remove
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>
        ) : null}
      </div>

      <div className="footer-button">
        <button onClick={handleClearButtonClick} style={{ marginRight: '15px' }}>
          {'Clear'}
        </button>
        <button style={{ marginRight: '15px' }} onClick={handleProceed}>
          {'Proceed'}
        </button>
      </div>
    </div>
  );
}

export default BarcodeScan90days;
